import { __assign } from "tslib";
import * as React from 'react';
import { PromoWidget, getCollectionDefinition, getWebSolutionData, extractTagsDefinition, } from '@wix/app-market-collection-widget';
import s from './style.scss';
import { config } from '../../../config';
import { getWebSolutionsBiData } from '../biData';
import { Path, Origin } from '../../..';
import { openOrAddApp, shouldRenderAsLink, isBundleAppAndNotInstalled, isBundleAppAndInstalled, getBundleAppSavedPrice, isBundleAppWithVoucher, sortSolutionsByInstalled, } from '../../../common/utils';
import { composer } from '../../../component-decorators/composer';
import { Heading } from 'wix-style-react';
import { addUrl } from '../../../common/addUrl';
import { useConfigContext } from '../../../config-context';
import { getReferralInfo, getTagName } from '../../../common/bi-events';
export var promoSectionDTOtoProps = function (sectionDTO, marketplaceStore, locale, signedInstance, impressionId) {
    var tagData = sectionDTO.tagData;
    var tagsToWebSolutions = tagData.tagsToWebSolutions;
    var _a = tagsToWebSolutions[0].webSolutions, tagsAndSubCategories = _a.tagsAndSubCategories, webSolutions = _a.webSolutions;
    var rootTagDefinition = getCollectionDefinition(tagsAndSubCategories[0].tag);
    var innerTagsDefinitions = extractTagsDefinition(tagsToWebSolutions);
    var webSolutionsData = webSolutions.map(function (solution, appIndex) {
        var _a;
        var images = solution.assetsMap.banners ||
            solution.assetsMap.images ||
            solution.assetsMap.screenshots;
        return __assign(__assign({}, getWebSolutionData(solution)), { appIndex: appIndex, poster: images.assets[0].url, showPremiumLabel: !marketplaceStore.siteIsPremium &&
                solution.baseInfo.pricing.isRequiredWixPremium, isInstalled: !!(marketplaceStore.installedApps &&
                ((_a = marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.findIndex(function (installedApp) {
                    return installedApp.webSolutionBase.id === solution.baseInfo.id;
                })) > -1), isBundleAppNotInstalled: isBundleAppAndNotInstalled(solution.baseInfo.id, marketplaceStore.bundleApps), isBundleAppInstalled: isBundleAppAndInstalled(solution.baseInfo.id, marketplaceStore.bundleApps), savedPrice: getBundleAppSavedPrice(solution.baseInfo.id, marketplaceStore.bundleApps), isVoucherApp: isBundleAppWithVoucher(solution.baseInfo.id, marketplaceStore.bundleApps) });
    });
    return {
        rootTagDefinition: rootTagDefinition,
        webSolutions: sortSolutionsByInstalled(webSolutionsData),
        innerTagsDefinitions: innerTagsDefinitions,
        collimp_id: impressionId,
    };
};
export var Promo = composer()
    .withMarketplaceStore()
    .withExperiments()
    .withPermissions()
    .compose(function (_a) {
    var rootTagDefinition = _a.rootTagDefinition, webSolutions = _a.webSolutions, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments, permissions = _a.permissions, collimp_id = _a.collimp_id;
    // tslint:disable-next-line: react-hooks-nesting
    var configContext = useConfigContext();
    var i18n = configContext.i18n, baseUrl = configContext.baseUrl;
    var biData = getWebSolutionsBiData(webSolutions, 'promo', rootTagDefinition.slug, marketplaceStore.metaSiteId, marketplaceStore.route, marketplaceStore.prevRoute, marketplaceStore.bundleApps, collimp_id);
    var referral = getReferralInfo(null, marketplaceStore.prevRoute);
    var referralTag = getTagName(marketplaceStore.route);
    return (React.createElement("div", { "data-hook": rootTagDefinition.slug },
        React.createElement(Heading, { appearance: "H2", dataHook: "widget-title", className: s.promoHeading }, rootTagDefinition.name),
        React.createElement("span", { className: s.widgetWrapper },
            React.createElement(PromoWidget, { i18n: i18n, as: shouldRenderAsLink(), solutions: addUrl(baseUrl, webSolutions), solutionsBiData: biData, onPromoClickHandler: function (solution) {
                    openOrAddApp(solution, marketplaceStore, biData[solution.appIndex], configContext, experiments, false, referral, referralTag);
                }, onBoxClick: function (solution) {
                    return config.goto({
                        path: Path.WEB_SOLUTION,
                        slug: solution.slug,
                        referral: referral,
                        appIndex: solution.appIndex,
                        referralTag: referralTag,
                        collimp_id: collimp_id,
                        referralSectionName: rootTagDefinition.slug,
                    });
                }, withPermissions: config.origin !== Origin.STANDALONE, permissions: permissions, hideCTA: true, collimp_id: collimp_id }))));
});
//# sourceMappingURL=Promo.js.map